import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const navigationItems = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-emerald-400 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-400 rounded-full filter blur-3xl"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <img src="/logo_drak.svg" alt="TRL logo" className="w-12 h-12" />
              <div>
                <h3 className="text-2xl font-bold">
                  Theophrastus Research Lab
                </h3>
                <p className="text-gray-400">
                  Research • Consulting • Strategy
                </p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed text-lg max-w-md">
              Combining scientific research and strategic consulting to address
              the pressing challenges of our time.
            </p>
          </div>
          <div>
            <h4
              className="text-lg font-semibold mb-6"
              style={{ color: "#7FB740" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-3">
              {navigationItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-gray-300 hover:text-[#7FB740] transition-colors duration-200 flex items-center space-x-2 group"
                  >
                    <ArrowRight
                      size={16}
                      className="group-hover:translate-x-1 transition-transform"
                    />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4
              className="text-lg font-semibold mb-6"
              style={{ color: "#7FB740" }}
            >
              Contact
            </h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin
                  size={20}
                  className="mt-1 flex-shrink-0"
                  style={{ color: "#7FB740" }}
                />
                <div className="text-gray-300">
                  <p>Mytilene, Lesvos Island</p>
                  <p>North Aegean, Greece</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail
                  size={20}
                  className="flex-shrink-0"
                  style={{ color: "#7FB740" }}
                />
                <a
                  href="mailto:info@trlab.eu"
                  className="text-gray-300 hover:text-[#7FB740] transition-colors"
                >
                  info@trlab.eu
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 mb-4 md:mb-0">
            © {new Date().getFullYear()} Theophrastus Research Lab. All rights
            reserved.
          </p>
          <div className="flex items-center space-x-6">
            <Link
              to="/terms"
              className="text-gray-400 transition-colors hover:text-[#7FB740]"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
